var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { INDRAIbeAdminMktService } from '@ibe.services/ibeadmin-mkt.indra.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./ibeadmin-mkt.indra.service";
var INDRAIBEEmailTesterService = /** @class */ (function () {
    function INDRAIBEEmailTesterService(_http, ibeAdminMarketService) {
        this._http = _http;
        this.ibeAdminMarketService = ibeAdminMarketService;
        this.CONFIRMATION_COMMERCIAL_JSON = './assets/data/email-mock-objects/email_confirmation_commercial.json';
        this.CONFIRMATION_AWARD_JSON = './assets/data/email-mock-objects/email_confirmation_award.json';
        this.CONFIRMATION_TTT_JSON = './assets/data/email-mock-objects/email_confirmation_TTT.json';
        this.TTT_WARNING_JSON = './assets/data/email-mock-objects/email_TTT_expiration_warning.json';
        this.TTT_EXPIRED_JSON = './assets/data/email-mock-objects/email_TTT_expired.json';
        this.CONFIRMATION_STOPOVER_JSON = './assets/data/email-mock-objects/email_confirmation_stopover.json';
        this.CONFIRMATION_COMMERCIAL_BRAZIL_TAXES_JSON = './assets/data/email-mock-objects/email_confirmation_commercial_brazil_taxes.json';
        this.ADD_MORE_COMMERCIAL_JSON = './assets/data/email-mock-objects/email_add_more_commercial.json';
    }
    INDRAIBEEmailTesterService.prototype.sendEmail = function (campaignId, emailTo, jsonFilePath) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._http.get(jsonFilePath).toPromise()];
                    case 1:
                        params = _a.sent();
                        console.log(JSON.stringify(params));
                        this.ibeAdminMarketService.sendEmail(campaignId, emailTo, params).subscribe(function (result) {
                            if (result.errors.length === 0) {
                                console.log('success');
                            }
                            else {
                                console.log(result.errors[0]);
                            }
                        }, function (error) {
                            console.log(JSON.stringify(error));
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    INDRAIBEEmailTesterService.prototype.send_ConfirmationEmail_commercial = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'TAP-EML-EXT-IBE-E001';
                this.sendEmail(campaignId, emailTo, this.CONFIRMATION_COMMERCIAL_JSON);
                return [2 /*return*/];
            });
        });
    };
    INDRAIBEEmailTesterService.prototype.send_ConfirmationEmail_award = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'TAP-EML-EXT-IBE-E002';
                this.sendEmail(campaignId, emailTo, this.CONFIRMATION_AWARD_JSON);
                return [2 /*return*/];
            });
        });
    };
    INDRAIBEEmailTesterService.prototype.send_ConfirmationEmail_TTT = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'TAP-EML-EXT-IBE-E004';
                this.sendEmail(campaignId, emailTo, this.CONFIRMATION_TTT_JSON);
                return [2 /*return*/];
            });
        });
    };
    INDRAIBEEmailTesterService.prototype.send_TTTexpirationWarningEmail = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'TAP-EML-EXT-IBE-E005';
                this.sendEmail(campaignId, emailTo, this.TTT_WARNING_JSON);
                return [2 /*return*/];
            });
        });
    };
    INDRAIBEEmailTesterService.prototype.send_TTTexpiredEmail = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'TAP-EML-EXT-IBE-E006';
                this.sendEmail(campaignId, emailTo, this.TTT_EXPIRED_JSON);
                return [2 /*return*/];
            });
        });
    };
    INDRAIBEEmailTesterService.prototype.send_ConfirmationEmail_stopover = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'TAP-EML-EXT-IBE-E003';
                this.sendEmail(campaignId, emailTo, this.CONFIRMATION_STOPOVER_JSON);
                return [2 /*return*/];
            });
        });
    };
    // for testing thymeleaf syntax/codes, use 'taxes-test' in ibeadmin campaign
    INDRAIBEEmailTesterService.prototype.send_ConfirmationEmail_commercial_test = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'taxes-test';
                this.sendEmail(campaignId, emailTo, this.CONFIRMATION_COMMERCIAL_JSON);
                return [2 /*return*/];
            });
        });
    };
    INDRAIBEEmailTesterService.prototype.send_addmore = function (emailTo) {
        if (emailTo === void 0) { emailTo = ''; }
        return __awaiter(this, void 0, void 0, function () {
            var campaignId;
            return __generator(this, function (_a) {
                campaignId = 'TAP-EML-EXT-IBE-E007';
                this.sendEmail(campaignId, emailTo, this.ADD_MORE_COMMERCIAL_JSON);
                return [2 /*return*/];
            });
        });
    };
    INDRAIBEEmailTesterService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAIBEEmailTesterService_Factory() { return new INDRAIBEEmailTesterService(i0.inject(i1.HttpClient), i0.inject(i2.INDRAIbeAdminMktService)); }, token: INDRAIBEEmailTesterService, providedIn: "root" });
    return INDRAIBEEmailTesterService;
}());
export { INDRAIBEEmailTesterService };
